"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CostManagementTilePane;
(function (CostManagementTilePane) {
    CostManagementTilePane[CostManagementTilePane["InventoryItemsPane"] = 0] = "InventoryItemsPane";
    CostManagementTilePane[CostManagementTilePane["ServiceItemsPane"] = 1] = "ServiceItemsPane";
    CostManagementTilePane[CostManagementTilePane["CostDistribution"] = 2] = "CostDistribution";
})(CostManagementTilePane || (CostManagementTilePane = {}));
exports.default = CostManagementTilePane;
